import { useQuery } from "@tanstack/react-query";
import type { ActivityEvent, ActivityPage } from "@/api/project-activity";
import { apiFetch } from "@/lib/api";
import { projectActivityKeys } from "@/lib/query";

export type { ActivityEvent, ActivityPage };

export function useProjectActivity(projectId: string, limit = 20, enabled = true) {
  return useQuery({
    queryKey: projectActivityKeys.project(projectId),
    queryFn: () => apiFetch<ActivityPage>(`/projects/${projectId}/activity?limit=${limit}`),
    enabled: enabled && !!projectId,
  });
}
